var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _text;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPm25 = function SvgPm25(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b6ede01e-73ad-46b5-8d3a-07dbdff9c509",
    "data-name": "Layer 1",
    viewBox: "0 0 150.06 101.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M84.63,86.34a30.49,30.49,0,1,1,30.49-30.49A30.51,30.51,0,0,1,84.63,86.34Zm0-57.13a26.65,26.65,0,1,0,26.64,26.64A26.68,26.68,0,0,0,84.63,29.21Z",
    transform: "translate(-10.09 -4.83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M84.63,26.61a1.92,1.92,0,0,1-1.92-1.92V12.88a1.92,1.92,0,1,1,3.84,0V24.69A1.92,1.92,0,0,1,84.63,26.61Z",
    transform: "translate(-10.09 -4.83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M67.47,32.06a1.93,1.93,0,0,1-1.67-1L59.89,20.87a1.92,1.92,0,0,1,3.33-1.93l5.91,10.23a1.93,1.93,0,0,1-.7,2.63A2,2,0,0,1,67.47,32.06Z",
    transform: "translate(-10.09 -4.83)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M57.33,43.78a2,2,0,0,1-1-.26L46.14,37.61a1.92,1.92,0,1,1,1.92-3.33l10.23,5.91a1.93,1.93,0,0,1-1,3.59Z",
    transform: "translate(-10.09 -4.83)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M53.46,57.78H41.65a1.93,1.93,0,0,1,0-3.85H53.46a1.93,1.93,0,1,1,0,3.85Z",
    transform: "translate(-10.09 -4.83)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M47.1,77.68a1.92,1.92,0,0,1-1-3.59l10.23-5.9a1.92,1.92,0,0,1,1.92,3.33l-10.23,5.9A1.85,1.85,0,0,1,47.1,77.68Z",
    transform: "translate(-10.09 -4.83)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M61.56,93.72a1.85,1.85,0,0,1-1-.26,1.92,1.92,0,0,1-.71-2.62L65.8,80.61a1.92,1.92,0,1,1,3.33,1.92L63.22,92.76A1.9,1.9,0,0,1,61.56,93.72Z",
    transform: "translate(-10.09 -4.83)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M84.63,100.75a1.92,1.92,0,0,1-1.92-1.92V87a1.92,1.92,0,1,1,3.84,0V98.83A1.92,1.92,0,0,1,84.63,100.75Z",
    transform: "translate(-10.09 -4.83)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M107.7,93.72a1.93,1.93,0,0,1-1.67-1l-5.9-10.23a1.92,1.92,0,1,1,3.33-1.92l5.9,10.23a1.91,1.91,0,0,1-.7,2.62A1.85,1.85,0,0,1,107.7,93.72Z",
    transform: "translate(-10.09 -4.83)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M122.16,77.68a1.85,1.85,0,0,1-1-.26L111,71.52a1.92,1.92,0,1,1,1.92-3.33l10.23,5.9a1.93,1.93,0,0,1,.7,2.63A1.9,1.9,0,0,1,122.16,77.68Z",
    transform: "translate(-10.09 -4.83)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M127.6,57.78H115.79a1.93,1.93,0,0,1,0-3.85H127.6a1.93,1.93,0,1,1,0,3.85Z",
    transform: "translate(-10.09 -4.83)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M111.93,42.19a1.92,1.92,0,0,1-1-3.59l10.23-5.9A1.92,1.92,0,0,1,123.12,36l-10.23,5.91A1.94,1.94,0,0,1,111.93,42.19Z",
    transform: "translate(-10.09 -4.83)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    d: "M100.21,30.48a2,2,0,0,1-1-.26,1.93,1.93,0,0,1-.71-2.63l5.91-10.23a1.92,1.92,0,0,1,3.33,1.92l-5.9,10.23A1.94,1.94,0,0,1,100.21,30.48Z",
    transform: "translate(-10.09 -4.83)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 74.35,
    cy: 5.54,
    r: 5.54
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 98.08,
    cy: 10.28,
    r: 5.54
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 115.48,
    cy: 27.69,
    r: 5.54
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 121.81,
    cy: 49.84,
    r: 5.54
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 115.48,
    cy: 71.99,
    r: 5.54
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 99.66,
    cy: 89.39,
    r: 5.54
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 74.35,
    cy: 95.72,
    r: 5.54
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 49.03,
    cy: 90.97,
    r: 5.54
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 33.21,
    cy: 73.57,
    r: 5.54
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 26.88,
    cy: 51.42,
    r: 5.54
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 33.21,
    cy: 29.27,
    r: 5.54
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "a19f9f32-6bda-4098-bf89-6eec65fbc80a",
    cx: 49.03,
    cy: 11.87,
    r: 5.54
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "abc1564d-324d-4788-b2a0-5abde88cc902",
    transform: "translate(61.53 50.1)"
  }, "PM", /*#__PURE__*/React.createElement("tspan", {
    x: 0.99,
    y: 17
  }, "2.5"))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPm25, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pm25.879abb39.svg";
export { ForwardRef as ReactComponent };